import showToast from '../components/ToastComponent';
import { RetryShipmentPayload } from '../interface/interface';
import { retryShipment } from '../service/retryShipment';

import { useMutation, useQueryClient } from '@tanstack/react-query';

const useRetryShipment = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationKey: ['retryShipment'],
    mutationFn: async ({ accessToken, orderId }: RetryShipmentPayload) => {
      const response = await retryShipment(accessToken, orderId);

      if (response === 200) {
        showToast({
          message: 'Shipment Created successfully',
          type: 'success',
        });
        qc.invalidateQueries({ queryKey: [accessToken, orderId] });
        return response;
      }
      showToast({
        message: 'Error while create shipment',
        type: 'warning',
      });
      return response;
    },
  });
};

export default useRetryShipment;
